import { PharmacLabel, PharmacSwitch } from '@pharmac/ui'
import { Control, Controller, FieldValues } from 'react-hook-form'

type ControlledSwitchProps = {
  control?: Control<FieldValues>
  label?: string
  name: string
  inverseValue?: boolean
  disabled?: boolean
}

export const ControlledSwitch = (props: ControlledSwitchProps) => {
  return (
    <>
      {!!props.label && <PharmacLabel marginSmallBottom>{props.label}</PharmacLabel>}
      <Controller
        name={props.name}
        control={props.control}
        render={({ field }) => (
          <PharmacSwitch
            disabled={props.disabled}
            value={props.inverseValue ? !field.value : field.value}
            onChange={(value) => {
              field.onChange(props.inverseValue ? !value : value)
            }}
          />
        )}
      />
    </>
  )
}
